import { FC } from 'react';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, IconButton, Typography } from '@mui/material';
import { FsRawNode } from '~/api/types';
import { useDeleteFilesMutation, useGetStorageQuery, useGetStorageStatsQuery } from '~/api/v2/hooks';
import { DeleteTypeEnum, SelectedFilesTable } from '~/components';
import { useBatchProcessing } from '~/hooks';
import { CloseIcon, TrashIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { filesListSelectedItemsContainerStyles, outlinedDeleteButtonStyles } from './styles';

interface SelectedFilesToDeleteProps {
  selectedFiles: FsRawNode[];
  removeSelectedIds?: () => void;
}

const SelectedFilesToDelete: FC<SelectedFilesToDeleteProps> = ({ selectedFiles, removeSelectedIds }) => {
  const dispatch = useAppDispatch();
  const [deleteFiles] = useDeleteFilesMutation({ fixedCacheKey: 'delete-file' });
  const { refetch: refetchStorage } = useGetStorageQuery({});
  const { refetch: refetchStats } = useGetStorageStatsQuery({});
  const { processBatches } = useBatchProcessing();

  const handleDeleteFiles = async () => {
    await processBatches(
      selectedFiles.map(({ path }) => path),
      async (chunk) => {
        return deleteFiles({ file_path_list: chunk }).unwrap();
      },
    );
    refetchStorage();
    refetchStats();
  };

  return (
    <>
      <Box sx={filesListSelectedItemsContainerStyles}>
        <IconButton onClick={removeSelectedIds}>
          <CloseIcon />
        </IconButton>
        <Typography>{selectedFiles.length} item(s) selected</Typography>
        <CustomButton buttonType="outlined">
          <Box
            sx={outlinedDeleteButtonStyles}
            onClick={() => {
              dispatch(
                openModal({
                  type: ModalTypesEnum.DELETE_CONFIRMATION,
                  payload: {
                    type: DeleteTypeEnum.FILES,
                    onDelete: () => handleDeleteFiles(),
                    content: <SelectedFilesTable selectedFiles={selectedFiles} />,
                    itemsCount: selectedFiles.length,
                  },
                }),
              );
            }}
          >
            <TrashIcon style={{ width: 16, height: 16, marginBottom: '2px' }} />
            Delete
          </Box>
        </CustomButton>
      </Box>
    </>
  );
};

export default SelectedFilesToDelete;
